/**
 * @fileoverview Global Error Capture provider component.
 * Mounts the useGlobalErrorCapture hook to capture unhandled errors.
 */

import { useGlobalErrorCapture } from '@/hooks/useGlobalErrorCapture';

export function GlobalErrorCapture() {
  useGlobalErrorCapture();
  return null;
}
